import { createSelector } from 'reselect';
import moment from 'moment';
import get from 'lodash/get';
import { cloneDeep, orderBy } from 'lodash';

import { SCOPE } from './types';
import { configViewSelector } from '../base/selectors';
import { DEFAULT_CONFIG_SORT, ERR_CONFIG_DATE_FORMAT } from '@utils/constants';

const selector = (state) => get(state, SCOPE);

export const loadingSelector = createSelector(selector, (configState) => ({
  loading: configState.isFetching,
  showError: configState.errorCode !== 0,
  errorMsg: configState.errorMsg,
}));

export const dataSelector = createSelector(selector, (configState) =>
  configState.response ? configState.response.data : {},
);

export const logDataSortSelector = createSelector(
  configViewSelector,
  dataSelector,
  (configData, tableData) => {
    const sort = { ...DEFAULT_CONFIG_SORT, ...(configData || {}) };
    const records: any[] = [];
    get(tableData, 'data', []).forEach((row) => {
      let state = '';
      switch (row.state) {
        case 0:
          state = 'Deleted';
          break;
        case 1:
          state = 'Disabled';
          break;
        case 2:
          state = 'Enabled';
          break;
      }
      const value = row.rules.map((ele) => `Error ${ele.operator} ${ele.value}`).join(' OR ');
      // build row data
      const updatedDate = moment(row.updatedAt).format(ERR_CONFIG_DATE_FORMAT);

      const rowData = cloneDeep(row);
      rowData.rules = value;
      rowData.updatedAt = updatedDate;
      rowData.state = state;
      records.push(rowData);
    });

    const sortKey = sort?.key || DEFAULT_CONFIG_SORT.key;
    const sortOrder = sort?.order || DEFAULT_CONFIG_SORT.order;

    const orderedRecords = orderBy(records, [sortKey], [sortOrder]);

    return {
      data: orderedRecords,
      sort: { ...sort, key: sortKey, order: sortOrder },
    };
  },
);

export default selector;
